export default __webpack_public_path__ + "static/media/ic_totaluser.ae09b310.svg";